import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import { useTranslation } from 'react-i18next';
import Grid from '@material-ui/core/Grid';
import TitlePage from '../../../../components/titlePage/TitlePage';

import AboutOfficeImg from '../../../../assets/images/building-onwr.png';
import FbLogo from '../../../../assets/logos/fb.png';
import YoutubeLogo from '../../../../assets/logos/youtube.png';
import XLogo from '../../../../assets/logos/x.png';

const useStyles = makeStyles((theme) => ({
  fontContent: {
    fontSize: '16px',
    [theme.breakpoints.down('xs')]: {
      fontSize: '14px',
    },
  },
  fontSocial: {
    fontFamily: theme.typography.fontKanit,
    fontSize: '1em',
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.9em',
    },
    fontWeight: 300,
    textDecoration: 'underline',
  },
  link: {
    color: 'black',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  imgOffice: {
    width: '200px',
    [theme.breakpoints.down('xs')]: {
      width: '130px',
    },
    [theme.breakpoints.only('sm')]: {
      width: '150px',
    },
  },
}));
export default function ContactForm() {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <div>
      <TitlePage title={t('ติดต่อเรา')} />
      <Box pb={2}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6} lg={5}>
            <Box pb={3}>
              <Typography variant="h5">
                {t('ศูนย์อำนวยการน้ำแห่งชาติ (ศอน.)')}
              </Typography>
            </Box>
            <Grid container direction="row" spacing={3}>
              <Grid item xs="auto">
                <img src={AboutOfficeImg} className={classes.imgOffice} alt="onwr-office" />
              </Grid>
              <Grid item xs>
                <Typography className={classes.fontContent}>
                  {t('เลขที่ 999 หมู่ 1')}
                </Typography>
                <Typography className={classes.fontContent}>
                  {t('ตำบลบางตลาด อำเภอปากเกร็ด')}
                </Typography>
                <Typography className={classes.fontContent}>
                  {t('จังหวัดนนทบุรี 11120')}
                </Typography>
                <Box py={2}>
                  <Typography className={classes.fontContent}>
                    {t('โทร')}
                    {' '}
                    : 0 2554 1800
                  </Typography>
                  <Typography className={classes.fontContent}>
                    {t('Fax')}
                    {' '}
                    : 0 2521 9140
                  </Typography>
                  <Typography className={classes.fontContent}>
                    {t('อีเมล')}
                    {' '}
                    : onwr@onwr.go.th
                  </Typography>
                </Box>
                <Box p1={2}>
                  <Box display="flex" alignItems="center">
                    <Box pr={1} py={1}><img src={FbLogo} alt="เข้าสู่ facebook สำนักงานทรัพยากรน้ำแห่งชาติ " /></Box>
                    <a href="https://www.facebook.com/onwr.go.th/" target="_blank" rel="noopener noreferrer" title="เข้าสู่ facebook สำนักงานทรัพยากรน้ำแห่งชาติ" className={classes.link}>
                      <Typography className={classes.fontSocial}>
                        {t('สำนักงานทรัพยากรน้ำแห่งชาติ ')}
                      </Typography>
                    </a>
                  </Box>
                  <Box display="flex" alignItems="center">
                    <Box pr={1} py={1}><img src={YoutubeLogo} alt="เข้าสู่ Youtube สำนักงานทรัพยากรน้ำแห่งชาติ " /></Box>
                    <a href="https://www.youtube.com/channel/UC688tWRdBwran6MWzVf6fOw" target="_blank" rel="noopener noreferrer" title="เข้าสู่ Youtube สำนักงานทรัพยากรน้ำแห่งชาติ" className={classes.link}>
                      <Typography className={classes.fontSocial}>
                        {t('สำนักงานทรัพยากรน้ำแห่งชาติ ')}
                      </Typography>
                    </a>
                  </Box>
                  <Box display="flex" alignItems="center">
                    <Box pr={1} py={1}><img src={XLogo} alt="เข้าสู่ X สำนักงานทรัพยากรน้ำแห่งชาติ " /></Box>
                    <a href="https://x.com/onwrnews" target="_blank" rel="noopener noreferrer" title="เข้าสู่ X สำนักงานทรัพยากรน้ำแห่งชาติ " className={classes.link}>
                      <Typography className={classes.fontSocial}>
                        {t('สำนักงานทรัพยากรน้ำแห่งชาติ ')}
                      </Typography>
                    </a>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} md={6} log={7}>
            <Box bgcolor="#E5E3DF" p={2} mx={{ xs: 0, md: 2, lg: 3, xl: 4 }} mt={{ xs: 0, md: -11 }} borderRadius={10} boxShadow={3}>
              <iframe
                title="ศูนย์อำนวยการน้ำแห่งชาติ (ศอน.)"
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3873.44879688966!2d100.5753487!3d13.8720921!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x30e2994401418cd7%3A0x63254def5f869791!2z4Liq4Liz4LiZ4Lix4LiB4LiH4Liy4LiZ4LiX4Lij4Lix4Lie4Lii4Liy4LiB4Lij4LiZ4LmJ4Liz4LmB4Lir4LmI4LiH4LiK4Liy4LiV4Li0!5e0!3m2!1sth!2sth!4v1717122634376!5m2!1sth!2sth"
                style={{ border: 0, height: '500px', borderRadius: 10 }}
                allowFullScreen
              />
            </Box>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
}
